export default {
      id: "family-1-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#family-1",
      toString: function () {
        return this.url;
      }
    }